module.exports = __webpack_public_path__ + "img/chevron-bar-left.ef0af4f2.svg";